module.exports = {
      id: "gn-reach-icon-usage",
      viewBox: "0 0 106 36",
      url: __webpack_public_path__ + "svg-sprite-58d03b3f1466f1d475a0d37264fe8fc2.svg#gn-reach-icon",
      toString: function () {
        return this.url;
      }
    }